import FictionaryItem from './FictionaryItem';

export default FictionaryItem;
